// assets/product-header-mobile.js
window.ProductHeaderHelper = (productSelector) => {
  const container = document.querySelector(productSelector);
  if (!container) return;
  
  const originalHeader = container.querySelector('.product-header');
  if (!originalHeader) return;

  const duplicateHeader = originalHeader.cloneNode(true);
  duplicateHeader.className = 'product-header product-header--mobile';
  
  const pr = duplicateHeader.querySelector('.price-reviews');
  if (pr) pr.id = '';
  
  container.prepend(duplicateHeader);

  // Observer seulement le prix
  const priceOriginal = originalHeader.querySelector('.price');
  if (priceOriginal) {
    const priceDuplicate = duplicateHeader.querySelector('.price');
    
    const priceObserver = new MutationObserver(() => {
      if (priceDuplicate) {
        priceDuplicate.innerHTML = priceOriginal.innerHTML;
      }
    });
    
    priceObserver.observe(priceOriginal, { 
      childList: true, 
      subtree: true,
      characterData: true 
    });
  }

  // Observer seulement le stock
  const stockOriginal = originalHeader.querySelector('.inventory');
  if (stockOriginal) {
    const stockDuplicate = duplicateHeader.querySelector('.inventory');
    
    const stockObserver = new MutationObserver(() => {
      if (stockDuplicate) {
        stockDuplicate.textContent = stockOriginal.textContent;
      }
    });
    
    stockObserver.observe(stockOriginal, { 
      childList: true, 
      characterData: true 
    });
  }
};